export const ZONES = ['LF', 'CF', 'RF', 'LA', 'CA', 'RA'] as const;
export type Zone = (typeof ZONES)[number];

const ZONE_SET: ReadonlySet<string> = new Set(ZONES);

export function isZone(value: string): value is Zone {
  return ZONE_SET.has(value);
}

export function zoneIndex(zone: Zone): number {
  return ZONES.indexOf(zone);
}

export function zoneFromIndex(index: number): Zone | undefined {
  if (index < 0 || index >= ZONES.length) return undefined;
  return ZONES[index];
}
